import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const CertificationsPage = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();

    const allCertificates = [
        { name: "TEC Type-1", img: "/tec_type1.png" },
        { name: "TEC Type-3", img: "/tec_type3.png" },
        { name: "ISO 14001:2015", img: "/iso_14001.png" },
        { name: "ISO 9001:2015", img: "/iso_9001.png" },
        { name: "Startup India", img: "/startup.png" },
        { name: "MSME ZED Bronze", img: "/zed_bronze.png" },
        { name: "Incorporation", img: "/incorporation.png" },
        { name: "IEC Certificate", img: "/iec.png" },
        { name: "Pollution Control", img: "/pollution.png" }
    ];

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Banner Section with Safe Inline Style */}
            <div
                className="relative h-[400px] w-full bg-cover bg-center flex items-center justify-center mb-12"
                style={{ backgroundImage: "url('/banner1.jpg')" }}
            >
                <div className="absolute inset-0 bg-blue-900/70 flex items-center justify-center">
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-4xl md:text-5xl font-extrabold text-white tracking-wider uppercase text-center px-4"
                    >
                        All Certifications
                    </motion.h1>
                </div>
            </div>

            <div className="container mx-auto px-4 md:px-12 pb-20">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-8 px-6 py-2 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition"
                >
                    ← Back
                </button>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
                    {allCertificates.map((cert, index) => (
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            key={index}
                            className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex flex-col items-center cursor-pointer justify-between"
                            onClick={() => setSelectedImage(cert)}
                        >
                            <img
                                src={cert.img}
                                alt={cert.name}
                                className="w-full h-48 object-contain rounded-lg"
                            />
                            <p className="mt-4 font-bold text-base text-gray-800 text-center">{cert.name}</p>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Modal for Zooming Image */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedImage(null)}
                        className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                    >
                        <motion.img
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                            src={selectedImage.img}
                            alt={selectedImage.name}
                            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                        />
                        <button
                            className="absolute top-5 right-5 text-white text-3xl font-bold"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default CertificationsPage;